import { Accordion } from '@/components/Accordion/Accordion';
import SupportIcon from '../../images/SupportIcon.svg?react';
import { Box } from '@/components/Box/Box';
import {
  SupportMenuItem,
  SupportMenuLink,
  SupportMenuMarker,
  SupportMenuSection,
  SupportMenuWrapper,
} from '@/bundle/Sidebar/ui/SidebarSupportMenu/styles';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { envConfig } from '@/config/envConfig';
import { CONTACT_MOBILE_PHONE, FORMATTED_CONTACT_MOBILE_PHONE } from '@/const/shared';

export const SidebarSupportMenu = () => {
  return (
    <SupportMenuWrapper>
      <Accordion
        header={(icon) => {
          return (
            <Box width='100%' display='flex' justifyContent='space-between' alignItems='center'>
              <Box display='flex' alignItems='center' columnGap='12px' padding='8px 12px'>
                <SupportIcon />
                <Typography variant='bodySmall' color={COLORS.grey[600]}>
                  Need support
                </Typography>
              </Box>
              {icon}
            </Box>
          );
        }}
      >
        <SupportMenuSection>
          <SupportMenuItem>
            <SupportMenuLink to={`mailto:${envConfig.SUPPORT_EMAIL_URL}`}>
              <SupportMenuMarker />
              {envConfig.SUPPORT_EMAIL_URL}
            </SupportMenuLink>
          </SupportMenuItem>
          <SupportMenuItem>
            <SupportMenuLink to={`tel:${CONTACT_MOBILE_PHONE}`}>
              <SupportMenuMarker />
              {FORMATTED_CONTACT_MOBILE_PHONE}
            </SupportMenuLink>
          </SupportMenuItem>
        </SupportMenuSection>
      </Accordion>
    </SupportMenuWrapper>
  );
};
